import { RoundingSettingConfig, type RoundingSetting } from '@pigello/pigello-matrix';
import type { RelationFieldProps } from './types';

export const RoundingSettingItem: RelationFieldProps<RoundingSetting> = {
  nested: [],
  filters: [],
  renderItem: (item) => ({
    title: item.title ?? item.id,
    badge: undefined,
    descriptionItems: RoundingSettingConfig.verboseName,
  }),
};
